export default "__VITE_ASSET__BspsLZKO__"